import { render, staticRenderFns } from "./RegisterContainer.vue?vue&type=template&id=1cc41baa&scoped=true&"
import script from "./RegisterContainer.vue?vue&type=script&lang=ts&"
export * from "./RegisterContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc41baa",
  null
  
)

export default component.exports